// src/components/BulkMessageManager/index.js
import BulkMessageManager from "./BulkMessageManager";

export default BulkMessageManager;
